import { render, staticRenderFns } from "./diaJumbleWord.vue?vue&type=template&id=fbe18c60"
import script from "./diaJumbleWord.vue?vue&type=script&lang=js"
export * from "./diaJumbleWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports